import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import Timeago from 'timeago.js';
import { Icon, Input, Dropdown, Menu, message } from 'antd';
import CONSTANT from '../../constant';
import History from '../../util/history';
import { formatDate, safeHttps } from '../../util';
import Emitter from '../../services/emitter';
import mElectronApi from '../../util/electron';
import ProjectApi from '../../services/api/project';
import StoreService from '../../services/api/store';
import Config from '../../config';
import {getInternational} from '../../util/env';

/**
 * Project Item
 *
 * @class ProjectItem
 * @extends {React.Component}
 */
class ProjectItem extends React.Component {

    /**
     * Creates an instance of ProjectItem.
     * @param {any} props
     */
    constructor(props) {
        super(props);
        this.state = {
            projectName: props.data.projectName,
            isImgLoaded: true
        };
    }

    handleClick = (project, isExample = false) => {
        History.push('/');
        if (isExample) {
            const { intlr } = this.props;
            const name = project.name[intlr.langKey] || project.name['en'];
            fetch(project.url).then(res => {
                return project.parseExt === 'mblock' ? res.arrayBuffer() : res.json();
            })
                .then(data => {
                    Emitter.emit('LoadExample', data, name);
                }, (error) => {
                    console.warn(error);
                });
        } else {
            Emitter.emit('OpenProject', project.id, 'yun', (err) => {
                if (err) return this.openFailCb(err);
            });
        }
    }

    openFailCb = (err) => {
        const { intlr } = this.props;
        if (err && err.code === 99999) {
            message.warn(intlr.messages['MSG.99999']);
            return;
        }
        console.log('err', err);
    }

    onFocusRename = () => {
        this.renameInput.input.select();
    }

    onChangeRename = (value) => {
        if (_.trim(value).length > 48) {
            const { intlr } = this.props;
            message.error(intlr.messages['PROJECT.NAME.MAX.LENGTH.TEXT']);
            value = value.substring(0, 48);
        }
        this.setState({ projectName: value });
    }

    onPressEnter = () => {
        this.renameInput.input.blur();
    }

    onRename = (value) => {
        const { id, projectId, projectName, syncStatus } = this.props.data;
        if (!_.trim(value) || _.trim(value) === projectName) {
            this.setState({ projectName });
            return;
        }
        this.setState({ projectName: _.trim(value) }, () => {
            const createdAt = Date.parse(new Date()) / 1000;
            Emitter.emit('RenameProject', { id, projectName: _.trim(value), createdAt, projectId, syncStatus }, 'yun', (err) => {
                if (err) {
                    return this.renameFailCb(err);
                }
            });
        });
    }

    renameFailCb = (err) => {
        console.log('err', err);
        const { projectName } = this.props.data;
        this.setState({ projectName });
    }

    content(data, isCustom) {
        const { intlr, account } = this.props;
        const { projectName, isImgLoaded } = this.state;
        const langKey = intlr.langKey === 'zh' ? 'zh_CN' : 'en';
        const { isInternational } = account;
        return isCustom ? (
            <div className="project-content">
                {
                    data.syncStatus === CONSTANT.PROJECT_STATUS['UPLOADING'] &&
                    <div className="project-content-loading" onClick={() => this.handleClick(data)}>
                        <Icon type="loading" spin />
                        <span>{intlr.messages['PROJECT.STATUS.UPLOADING']}</span>
                    </div>
                } {
                    account.isLogin && data.syncStatus === CONSTANT.PROJECT_STATUS['WILL_DOWNLOAD'] &&
                    <span className="project-status">{intlr.messages['PROJECT.STATUS.WILLDOWNLOAD']}</span>
                } {
                    account.isLogin && _.indexOf([CONSTANT.PROJECT_STATUS['WILL_UPLOAD_RECORD'], CONSTANT.PROJECT_STATUS['WILL_UPLOAD_FILE'], CONSTANT.PROJECT_STATUS['WILL_UPLOAD_ALL']], data.syncStatus) > -1 &&
                    <span className="project-status">{intlr.messages['PROJECT.STATUS.WILLUPLOAD']}</span>
                } {
                    account.isLogin && !isInternational && data.syncStatus !== CONSTANT.PROJECT_STATUS['WILL_DOWNLOAD'] && data.projectId && !data.isShare &&
                    <span className="project-share" onClick={() => this.handleMenuClick({ key: 'PROJECT.MENU.SHARE' })}>{intlr.messages['PROJECT.MENU.SHARE']}</span>
                    // <i className="mblock-icon icon-fabu project-share" onClick={() => this.handleMenuClick({ key: 'PROJECT.MENU.SHARE' })} />
                }
                <span className="project-img" onClick={() => this.handleClick(data)}>
                    {
                        data.coverImage && isImgLoaded
                            ? <img src={safeHttps(data.coverImage)}
                                onError={() => this.setState({ isImgLoaded: false })}
                                onLoad={() => this.setState({ isImgLoaded: true })} />
                            : <div className="defaultImg"><i className="mblock-icon icon-tubiaoweijiazai" /></div>
                    }
                </span>
                <div className="project-name text-overflow">
                    <span>
                        <Input value={projectName}
                            title={projectName}
                            disabled={data.syncStatus === CONSTANT.PROJECT_STATUS['WILL_DOWNLOAD']}
                            ref={rinput => this.renameInput = rinput}
                            onClick={this.onFocusRename}
                            onChange={e => this.onChangeRename(e.target.value)}
                            onPressEnter={this.onPressEnter}
                            onBlur={e => this.onRename(e.target.value)}
                            autoComplete="off" />
                        <p className="text-overflow">{Timeago().format(formatDate(data.createdAt), langKey)}</p>
                    </span>
                    {this.dropDown()}
                </div>
            </div>
        ) : (
            <div className="project-content">
                <span className="project-img" onClick={() => this.handleClick(data, true)}>
                    {/* <span className="img-placeholder" style={{ backgroundImage: `url(${data.image})` }} /> */}
                    <img src={safeHttps(data.image)}/>
                </span>
                <div className="project-name text-overflow">
                    <span>
                        <Input value={data.name[intlr.langKey] || data.name['en']} disabled title={data.name[intlr.langKey] || data.name['en']} />
                    </span>
                </div>
            </div>
        );
    }

    dropDown = () => {
        const { data } = this.props;
        if (data.syncStatus === CONSTANT.PROJECT_STATUS['WILL_DOWNLOAD']) {
            return null;
        }
        return (
            <Dropdown
                trigger={['click']}
                overlay={this.dropdownMenu()}
                placement="topRight">
                <span className="item-menu">
                    <i className="mblock-icon icon-sangedian" />
                </span>
            </Dropdown>
        );
    }

    dropdownMenu = () => {
        const { intlr } = this.props;
        const { messages } = intlr;
        return (
            <Menu className="item-dropdown-menu" onClick={this.handleMenuClick}>
                {
                    this.dropdownMenuItem().map((m) => (
                        <Menu.Item key={m.key}>{messages[m.key]}</Menu.Item>
                    ))
                }
            </Menu>
        );
    };

    dropdownMenuItem = () => {
        const { data, account } = this.props;
        const { isShare, projectId } = data;
        const { isInternational } = account;
        let menus = [
            { key: 'PROJECT.MENU.OPEN', order: 1 },
            { key: 'PROJECT.MENU.RENAME', order: 3 },
            { key: 'PROJECT.MENU.COPY', order: 4 },
            { key: 'PROJECT.MENU.EXPORT', order: 5 }
        ];
        !isInternational && account.isLogin && projectId &&
            (isShare
                ? menus = menus.concat([
                    { key: 'PROJECT.MENU.EDITSHARED', order: 2 },
                    { key: 'PROJECT.MENU.CANCELSHARE', order: 6 }
                ])
                : menus = menus.concat([
                    { key: 'PROJECT.MENU.SHARE', order: 2 }
                ])
            );
        !isShare && (menus = menus.concat([{ key: 'PROJECT.MENU.DELETE', order: 7 }]));
        return _.sortBy(menus, 'order');
    }

    handleMenuClick = async (item) => {
        const { data } = this.props;
        if (item.key === 'PROJECT.MENU.OPEN') {
            this.handleClick(data);
        } else if (item.key === 'PROJECT.MENU.RENAME') {
            this.onFocusRename();
        } else if (item.key === 'PROJECT.MENU.COPY') {
            Emitter.emit('CopyProject', data);
        } else if (item.key === 'PROJECT.MENU.EXPORT') {
            Emitter.emit('ExportProject', data, 'fs', (err) => {
                if (err) return this.openFailCb(err);
            });
        } else if (item.key === 'PROJECT.MENU.DELETE') {
            History.push(`/list/project/delete/${data.id}`);
        } else if (item.key === 'PROJECT.MENU.SHARE') {
            History.push(`/list/project/share/${data.id}`);
        } else if (item.key === 'PROJECT.MENU.EDITSHARED') {
            const res = await ProjectApi.get_url_token({
                '_HEADER_': { 'utoken': StoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY) }
            });
            const protocol = Config.domain.cloud[getInternational()] + 'project/' + data.projectId + '?urltoken=' + res.urltoken;
            mElectronApi.openLink(item.domEvent, protocol);
        } else if (item.key === 'PROJECT.MENU.CANCELSHARE') {
            History.push(`/list/project/cancelShare/${data.id}`);
        }
        return true;
    }

    render() {
        const { data, isCustom = false } = this.props;

        return (
            <div className="item">
                <div className="item-content-container">
                    {this.content(data, isCustom)}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    account: state.account,
    intlr: state.intlr
});

export default connect(
    mapStateToProps
)(ProjectItem);
